export default __webpack_public_path__ + "static/media/Smart-Biology-LIFE-U3-Cover-Image.830d921c.jpg";